import React from 'react';
import ReactDOM from 'react-dom';
import './styles/index.css';
import './styles/global.css';
import './styles/ShiftCalendar.css';
import './styles/StoresPage.css';
import './styles/StaffPage.css';
import App from './App';

// デバッグ用のログ
console.log('NEKONOTE: index.js loaded');

// DOMのロード完了を待つ
document.addEventListener('DOMContentLoaded', () => {
  const rootElement = document.getElementById('nekonote-app');
  if (rootElement) {
    try {
      console.log('NEKONOTEアプリケーションの初期化を開始します');
      console.log('data-page属性:', rootElement.getAttribute('data-page'));
      
      ReactDOM.render(<App />, rootElement);
      console.log('NEKONOTEアプリケーションのレンダリングが完了しました');
    } catch (error) {
      console.error('レンダリングエラー:', error);
      rootElement.innerHTML = '<div style="color:red;padding:20px;border:1px solid red;">エラーが発生しました: ' + error.message + '</div>';
    }
  } else {
    console.error('#nekonote-app 要素が見つかりません');
  }
});
